module.exports = __webpack_public_path__ + "img/mission-gfj-banner.jpg?917af2c36ee4a1f4ae5c2716eb00010b";